import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { MultiSelectComponent } from '@farris/ui-multi-select';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[multiSelectRef]'
})
export class MultiSelectComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: MultiSelectComponent, public elementRef: ElementRef, public frameContext: FrameContext) { 
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}